import { Box } from 'app/components/design-system-components'
import { CheckboxesList } from 'app/components/design-system-components/list-filters/CheckboxesList'
import { DropdownBodySectionHeader } from 'app/components/design-system-components/list-filters/DropdownBodySectionHeader'
import { theme } from 'app/match/applicationReportPDF/assets/theme'

export const statusFiltersFields = {
  status: 'status',
}

export const isStatusFilterApplied = (statusFilterValues: any) =>
  statusFilterValues &&
  statusFilterValues[statusFiltersFields.status] &&
  Object.values(statusFilterValues[statusFiltersFields.status]).length

export const statusDataExtractor = (filterValues: any) => {
  const { [statusFiltersFields.status]: statusesObj } = filterValues
  return {
    statuses: Object.values(statusesObj ?? {}).map(
      ({ optionMeta }: any) => optionMeta.id,
    ),
  }
}

export const getStatusFilterState = (status: any) =>
  Object.values(status?.status || {}).map(
    ({ optionMeta }: any) => optionMeta?.id,
  )

export const StatusAppliedFilterRenderer = ({ filterValues }: any) => {
  const { [statusFiltersFields.status]: status } = filterValues
  return Object.values(status)
    .map((statusObj: any) => statusObj.optionMeta.displayText)
    .join(', ')
}

export const StatusFilterBody = ({
  formBag: { values, setFieldValue },
  statusOptions,
}: any) => {
  const onCheckBoxClicked = (checked: boolean, option: any) => {
    const statusValues = values[statusFiltersFields.status]

    if (checked) {
      setFieldValue(statusFiltersFields.status, {
        [option.optionMeta.id]: option,
      })
    } else {
      const { [option.optionMeta.id]: uncheckedOption, ...otherOptions } =
        statusValues
      setFieldValue(statusFiltersFields.status, {
        ...otherOptions,
      })
    }
  }

  const statusValues = values[statusFiltersFields.status] || {}

  let statusesOptions = Object.values(statusOptions).map(
    (status: any, idx) => ({
      option: status,
      optionMeta: {
        id: status.value,
        displayText: statusOptions[idx]?.name,
        noSeparator: true,
      },
    }),
  )

  statusesOptions = statusesOptions.slice(1)

  return (
    <>
      <Box style={{ maxHeight: '300px', overflowY: 'auto' }}>
        <DropdownBodySectionHeader
          header="STATUSES"
          containerProps={{ mb: theme.space[4] + 'px' }}
        />
        <CheckboxesList
          options={statusesOptions}
          checkedOptions={statusValues}
          onCheckBoxClicked={onCheckBoxClicked}
        />
      </Box>
    </>
  )
}
